// extracted by mini-css-extract-plugin
export default {"ChatMessage":"ChatMessageDisplay_ChatMessage__5c175","ShowOnHover":"ChatMessageDisplay_ShowOnHover__2Po2Z"};